'use client';
import { FC } from 'react';
import { fetchRecommendedVehicles, fetchSimilarVehicles } from 'src/data/ProductApi/ProductApiListVehicles';
import { Skeleton } from 'src/general/components/Skeleton/Skeleton';
import { ProductListDataPayload } from 'src/types/CataloguePage.types';
import useSWR from 'swr';
import { SuggestedCarsGridContent } from '../SuggestedCarsGridContent/SuggestedCarsGridContent';

const MAX_TOTAL_TO_SHOW_SIMILAR_CARS = 15;

type ResultsSuggestionsProps = {
  total: number;
  sku?: string;
};

export type SuggestionType = 'recommendedCars' | 'similarCars';

const LIMIT = 12;

export const ResultsSuggestions: FC<ResultsSuggestionsProps> = ({ total, sku }) => {
  const shouldDisplaySection = total < MAX_TOTAL_TO_SHOW_SIMILAR_CARS;
  const { data, isLoading } = useSWR<ProductListDataPayload>(
    shouldDisplaySection ? ['plp-results-suggestions', sku] : null,
    ([_, sku]) => {
      if (sku) {
        return fetchSimilarVehicles(sku as string, LIMIT);
      } else {
        return fetchRecommendedVehicles();
      }
    },
  );

  if (!shouldDisplaySection) {
    return null;
  }

  const suggestionType: SuggestionType = sku ? 'similarCars' : 'recommendedCars';
  const showLoading = isLoading || !data?.results;

  return (
    <div className="mt-12 border-t border-bor-neu-mut pt-10" data-testid={`${suggestionType}-grid-content`}>
      {showLoading ? (
        <Skeleton />
      ) : (
        <SuggestedCarsGridContent
          title={'Some cars we think you might like based on your search'}
          results={data.results}
          suggestionType={suggestionType}
          recommendationId={data.recommendation_id ?? null}
        />
      )}
    </div>
  );
};
